<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'SkistarResortsSelect',
  computed: {
    ...mapState({
      resort: state => state.skistar.resorts.resort,
      resorts: state => state.skistar.resorts.items,
      resortsError: state => state.skistar.resorts.itemsError,
      resortsLoading: state => state.skistar.resorts.itemsLoading,
    }),
  },
  methods: {
    ...mapActions({
      loadResorts: 'skistar/loadResorts',
      setResort: 'skistar/setResort',
    }),
    refreshResorts() {
      if (this.resortsError) {
        this.loadResorts();
      }
    },
  },
};
</script>

<template>
    <v-select
      @input="setResort"
      @click:append="refreshResorts"
      :value="resort"
      :items="resorts"
      :loading="resortsLoading"
      :label="$t('skistar.resorts.title')"
      :disabled="resortsLoading"
      :error-messages="resortsError ? $t('skistar.resorts.error') : undefined"
      :error="!!resortsError"
      :append-icon="!resortsError ? '$vuetify.icons.dropdown' : 'refresh'"
      item-value="id"
      item-text="name"
    >
    </v-select>
</template>



// WEBPACK FOOTER //
// src/components/ski/skistar/SkistarResortsSelect.vue